/* ToolbarSection.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolbarSection.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
export var SeparatorPosition = /*#__PURE__*/function (SeparatorPosition) {
  SeparatorPosition["START"] = "start";
  SeparatorPosition["END"] = "end";
  return SeparatorPosition;
}({});
var styles = {
  container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
var separator = null;
var ToolbarSeparator = function ToolbarSeparator() {
  return /*#__PURE__*/React.createElement("div", {
    "data-toolbar-component": "separator",
    role: "separator",
    "aria-orientation": "vertical",
    className: ax(["_195gu2gc _4t3igktf _1bsbt94y _bfhkmuej"])
  });
};
export var ToolbarSection = function ToolbarSection(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    hasSeparator = _ref.hasSeparator;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.container),
    testId: testId,
    "data-toolbar-component": "section"
  }, hasSeparator === SeparatorPosition.START && /*#__PURE__*/React.createElement(ToolbarSeparator, null), children, hasSeparator === SeparatorPosition.END && /*#__PURE__*/React.createElement(ToolbarSeparator, null));
};